import { useLocation } from "wouter";

// Base path for in-app admin navigation. Wouter has no router base, so a bare
// setLocation("/admin/accounts/…") from an org-scoped page lands on the legacy
// unscoped route and drops the org from the URL — after which OrganizationContext
// falls back to its default slug and every org-derived link (e.g. the customer
// order-page button) points at the wrong tenant. Derive the base from the URL,
// same rule as the admin nav bar.
export function useAdminBasePath(): string {
  const [location] = useLocation();
  const match = location.match(/^\/org\/([^/]+)\/admin/);
  return match ? `/org/${match[1]}/admin` : "/admin";
}
